import { IVisualProps } from 'builder/components/CIO-Dasboard-2.0/types'
import * as Styled from './styles'

export const ExpertHelpVisual = ({ imgUrl, alt }: IVisualProps) => {
  return (
    <Styled.VisualContainer>
      <Styled.VisualImageContainer>
        <Styled.VisualImage src={imgUrl} alt={alt} />
      </Styled.VisualImageContainer>
    </Styled.VisualContainer>
  )
}
